var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
var dateFormat = 'DD/MM/YYYY';
export var ApDatePicker = function (props) {
    var _a;
    var name = props.name;
    return (_jsx(LocalizationProvider, __assign({ dateAdapter: AdapterDayjs }, { children: _jsx(DesktopDatePicker, { label: props.label, inputFormat: (_a = props.dateFormat) !== null && _a !== void 0 ? _a : dateFormat, disableFuture: props.disableFuture, disablePast: props.disablePast, disabled: props.disabled, value: props.formik.values[name], onChange: function (e) { props.formik.setFieldValue(name, e); }, renderInput: function (params) {
                return _jsx(TextField, __assign({ InputLabelProps: { shrink: true } }, params, { size: props.size, error: props.formik.touched[name] && Boolean(props.formik.errors[name]), helperText: props.formik.touched[name] && props.formik.errors[name], onBlur: props.formik.handleBlur }));
            }, views: props.views }) })));
};
